import "vue/jsx";

// ⚠️ 关键修复：在生产环境保护原生 XMLHttpRequest（强制恢复）
// 注意：主要的保护代码应该在 index.html 的内联脚本中执行
// 这里作为强制恢复，确保在 JS 模块加载时也能恢复
if (typeof window !== "undefined") {
  // 强制恢复原生 XMLHttpRequest
  if (window.__ORIGINAL_XMLHttpRequest__) {
    try {
      const testXhr = new window.XMLHttpRequest();
      if (!testXhr || typeof testXhr.upload === "undefined") {
        // 如果当前 XMLHttpRequest 无效，强制恢复原生版本
        window.XMLHttpRequest = window.__ORIGINAL_XMLHttpRequest__;
        console.log("[Main.ts] XMLHttpRequest forcefully restored");
      } else {
        // 即使有效，也确保使用原生版本（防止被替换）
        window.XMLHttpRequest = window.__ORIGINAL_XMLHttpRequest__;
      }
    } catch (e) {
      // 恢复失败，强制使用保存的原生版本
      window.XMLHttpRequest = window.__ORIGINAL_XMLHttpRequest__;
      console.log("[Main.ts] XMLHttpRequest restored after error");
    }
  }

  // 持续监控：在 element-plus 加载前再次检查
  const checkAndRestore = () => {
    if (window.__ORIGINAL_XMLHttpRequest__) {
      try {
        const test = new window.XMLHttpRequest();
        if (!test || typeof test.upload === "undefined") {
          window.XMLHttpRequest = window.__ORIGINAL_XMLHttpRequest__;
          console.log("[Main.ts] XMLHttpRequest restored in checkAndRestore");
        }
      } catch (e) {
        window.XMLHttpRequest = window.__ORIGINAL_XMLHttpRequest__;
      }
    }
  };

  // 立即检查
  checkAndRestore();

  // 在下一个事件循环中再次检查（确保在 element-plus 加载前）
  setTimeout(checkAndRestore, 0);
  setTimeout(checkAndRestore, 10);
  setTimeout(checkAndRestore, 50);
}

// 引入unocss
import "@/plugins/unocss";

// 导入全局的svg图标
import "@/plugins/svgIcon";

// 初始化多语言
import { setupI18n } from "@/plugins/vueI18n";

// 引入状态管理
import { setupStore } from "@/store";

// 全局组件
import { setupGlobCom } from "@/components";

// 引入element-plus
import { setupElementPlus } from "@/plugins/elementPlus";

// 引入全局样式
import "@/styles/index.less";

// 引入动画
import "@/plugins/animate.css";

// 路由
import { setupRouter } from "./router";

import { createApp } from "vue";

import App from "./App.vue";

import "./permission";

// 强制设置Element Plus主题色
import { setCssVar } from "@/utils";
setCssVar("--el-color-primary", "#60f8b6");

// 导入版本信息
import { VERSION } from "./version";

// 创建实例
const setupAll = () => {
  const app = createApp(App);

  setupI18n(app);

  setupStore(app);

  setupGlobCom(app);

  setupElementPlus(app);

  setupRouter(app);

  app.mount("#app");

  // 打印控制台欢迎信息
  console.log(`🎉 Welcome to OribitHub Admin Panel!`);
  console.log(`📦 Current Version: v${VERSION}`);
};

setupAll();
